import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import Tooltip, { type TooltipProps } from '@mui/material/Tooltip';
import { forwardRef, type ReactNode } from 'react';

interface IconButtonWithTooltipProps extends Omit<IconButtonProps, 'title'> {
  title: ReactNode;
  placement?: TooltipProps['placement'];
  slotProps?: {
    tooltip?: Partial<TooltipProps>;
  };
}

export const IconButtonWithTooltip = forwardRef<
  HTMLButtonElement,
  IconButtonWithTooltipProps
>(({ title, placement = 'bottom', disabled, slotProps, ...props }, ref) => {
  const icon = (
    <IconButton
      ref={ref}
      size="small"
      disabled={disabled}
      {...props}
      sx={{
        '&:disabled': {
          color: 'slate.300',
        },
        ...props.sx,
      }}
    />
  );

  return (
    <Tooltip
      title={title}
      placement={placement}
      enterDelay={500}
      {...slotProps?.tooltip}
    >
      {disabled ? <span>{icon}</span> : icon}
    </Tooltip>
  );
});

if (process.env.NODE_ENV !== 'production') {
  IconButtonWithTooltip.displayName = 'IconButtonWithTooltip';
}
